import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import CustomOutlinedButton from './Mui/CustomOutlinedButton';

import Loader from './Loader'

import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';
import {table as styles} from './Mui/styles';

import Icon from '@material-ui/core/Icon';

import CustomDialog from './inputs/CustomDialog'
// import TemplatePreview from './TemplatePreview'
import InstaTable from './InstaTable'
import RedeemIcon from './Mui/RedeemIcon'

import {
  vouchers_index,
  activate_voucher,
  revoke_voucher,
  resend_voucher,
  clear_voucher,
  delete_voucher,
  coupons_select,
  templates_select,
  businesses_select,
  preferences_index,
  set_path,
} from '../actions'

import {
  is_logged_on,
  is_validating,
  capitalize
 } from "../helpers"

const mapStateToProps = state => {
  const { items, pagination, totals } = state.voucher
  return {
    voucher: state.voucher,
    vouchers: items,
    pagination: pagination,
    totals: totals,
    current_user: state.auth.current_user.data,
    skills: state.skill.items,
    coupons: state.coupon.select_items,
    templates: state.template.select_items,
    businesses: state.business.select_items,

  }
}

const mapDispatchToProps = dispatch => {
  return {
    getVouchers: (page=1, per_page=10, filters={}, sort='', order='') => dispatch( vouchers_index(page, per_page, filters, sort, order) ),
    activateVoucher: (voucher_id, index=true, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(activate_voucher(voucher_id, index, page, per_page, filters, sort, order)),
    deleteVoucher: (voucher_id, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(delete_voucher(voucher_id, page, per_page, filters, sort, order)),
    revokeVoucher: (voucher_id, index=true, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(revoke_voucher(voucher_id, index, page, per_page, filters, sort, order)),
    resendVoucher: (voucher_id, index=true, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(resend_voucher(voucher_id, index, page, per_page, filters, sort, order)),
    getPreferences: () => dispatch( preferences_index() ),
    getCoupons: () => dispatch( coupons_select() ),
    getTemplates: () => dispatch( templates_select() ),
    getBusinesses: () => dispatch( businesses_select() ),
    clearVoucher: () => dispatch( clear_voucher() ),
    setPath: path => dispatch( set_path(path) ),
  }
}

class ConnectedVouchersIndex extends React.Component {
  state={
    current_voucher: null,
    current_view: 'all',
    merge_filters: {},
    current_id: undefined,
    filterState: {},
    mounted: false
  }

  fieldGetter(field, item, instate) {
    let renderText
    const state = {
      ...instate,
      filters: {
        ...instate.filters,
        ...this.state.merge_filters
      }
    }
    if (field === "created_at") {
      renderText = new Date(item[field]).toLocaleDateString()
    } else if (field === "status") {
      renderText = this.statusIcon(item[field])
    } else if (field === 'user') {
      renderText = (
        <Link to={`/busers/${item.user_id}/edit`} className="test_results_link" title="Edit User" target="_blank" onClick={e => {
          e.stopPropagation()
        }}>
          <div className="td-user-email">{item.display_name}</div>
          <div className="td-user-name">{item.email}</div>
        </Link>
      )
    } else if (field === 'coupon') {
      renderText = item.coupon_name
    } else if (field === 'template') {
      renderText = item.template_name
    } else if (field === 'skill') {
      renderText = item.skill_name
    } else if (field === 'business') {
      renderText = item.business_name
    } else if (field === 'id') {
      renderText = item[field]
    } else if (field === 'discount') {
      renderText = item.discount > 0 ? `${parseInt(item.discount * 100, 10)} %` : `${item.value.toFixed(2)} €`
    } else if (field === 'limit' || field === 'usage' ) {
      renderText = item[field]
    } else if (field === "actions" ) {
      renderText = (
        <React.Fragment>
          { item.status === "revoked" && this.activateLink(item, state) }
          { item.status === "active" && this.revokeLink(item, state) }
          { item.status === "active" && this.resendLink(item, state) }
          { item.status === "revoked" && this.deleteLink(item, state) }
        </React.Fragment>
      )
    } else {
      renderText = item[field] ? capitalize(item[field]) : ''
    }
    return renderText
  }

  componentWillMount() {
    const { getVouchers, getBusinesses, getCoupons, getTemplates, getPreferences, location } = this.props
    let initFilters
    if (location && location.state && location.state.business) {
      initFilters = {
        ...initFilters,
        business: location.state.business
      }
    }
    this.setState({initFilters: initFilters})

    getBusinesses()
    getCoupons()
    getTemplates()
    getPreferences()

    getVouchers(1, 10, initFilters, '', '')
    this.props.setPath('vouchers')
}

  componentWillUnmount() {
    // this.props.resetTemplate()
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.mounted) {
      if (prevProps.voucher.fetching && !this.props.voucher.fetching && this.props.voucher.fetched) {
        this.setState({mounted: true})
      }
    }
  }

  handleStatus = value => {
    if (value === 'all') {
      this.setState({merge_filters: {}})
    } else {
      this.setState({merge_filters: {status: value}})
    }
    this.setState({current_view: value})
  }

  activateLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Activate Voucher" onClick={e=>{
        e.preventDefault()
        this.props.activateVoucher(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>check_circle</Icon>
      </Link>
    )
  }

  revokeLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Revoke Voucher" onClick={e=>{
        e.preventDefault()
        this.props.revokeVoucher(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>delete</Icon>
      </Link>
    )
  }

  resendLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Resend Notification" onClick={e=>{
        e.preventDefault()
        this.props.resendVoucher(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>mail</Icon>
      </Link>
    )
  }

  deleteLink = (item, state) => {
    const {id} = item
    const {current_user} = this.props
    // const {filters, sort, order, page, per_page} = state
    if (
      current_user.role === "admin"
    ) {
      return (
        <Link to="" className="action-btn" title="Permanently delete" onClick={e=>{
            e.preventDefault()
            this.setState({showDialog: true, current_id: id, filterState: state})
        }}>
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>delete_forever</Icon>
        </Link>
      )
    }
    return ''
  }

  destroy = id => {
    const {filters, sort, order, page, per_page} = this.state.filterState
    this.props.deleteVoucher(id, page, per_page, filters, sort, order)
    this.hideDialog()
    this.setState({filterState: {}})
  }

  hideDialog() {
    this.setState({showDialog: false, current_voucher: {}})
  }

  statusIcon = status => {
    let icon = null
    if (status === 'active') {
      icon = 'check_circle'
    } else if (status === 'consumed') {
      icon = "done_all"
    } else if (status === 'revoked') {
      icon = "delete"
    }
    if (icon !== null) {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title={capitalize(status)}>{icon}</Icon>
    }
  }

  showPreview = item => {
    // this.setState({showPreview: true, current_template: template})
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { role } = this.props.current_user

    if ( role !== 'admin' ) {
      return <Redirect to="/" />
    }

    const { vouchers, pagination, totals, skills, businesses, coupons, templates } = this.props

    if (!this.state.mounted) {
      return <Loader />
    }

    const columns = [
      { id: 'id', disablePadding: true, label: 'ID', disableSort: true },
      { id: 'user', disablePadding: true, label: 'User' },
      { id: 'coupon', disablePadding: true, label: 'Coupon' },
      { id: 'template', disablePadding: true, label: 'Template' },
      { id: 'skill', disablePadding: true, label: 'Skill' },
      { id: 'business', disablePadding: true, label: 'Business', requires: ['admin'] },
      { id: 'status', disablePadding: true, label: 'Status', disableSort: true },
      { id: 'discount', disablePadding: true, label: 'Discount', disableSort: true, requires: ['admin']  },
      // { id: 'valid_from', disablePadding: true, label: 'Issue'  },
      // { id: 'valid_to', disablePadding: true, label: 'Expiry'  },
      { id: 'created_at', disablePadding: true, label: 'Creation' },
      { id: 'actions', disablePadding: true, label: 'Actions', disableSort: true },
    ]

    const filterControls = [
      { name: "business", filter_type: "select", valueField: "name", collection: businesses, requires: ['admin'] },
      { name: "coupon", filter_type: "select", valueField: "name", collection: coupons.filter(c => c.voucherable) },
      { name: "template", filter_type: "select", valueField: "name", collection: templates },
      { name: "skill", filter_type: "select", valueField: "name", collection: skills },
      { name: "search", filter_type: "search" },
      { name: "created_at", filter_type: "date" },
    ]

    const statuses = [
      { name: "all", label: "All", value: totals.all },
      { name: "active", label: "Active", value: totals.active },
      { name: "consumed", label: "Consumed", value: totals.consumed },
      { name: "revoked", label: "Revoked", value: totals.revoked },
    ]

    return (
      <div id="feedbacks-wrapper" className={this.props.voucher.fetching ? "fetching-list" : ''}>
        <div className="d-flex justify-content-between mb-40">
          <Typography className=" fw-bold h4">
            Vouchers
          </Typography>
          <CustomOutlinedButton
            component={Link}
            to="/vouchers/new"
            className="buttonnoto c-blue align-self-center"
            onClick={e=> this.props.setPath("addvoucher")}
            >Add Voucher
          </CustomOutlinedButton>
        </div>

        <InstaTable
          statuses={statuses}
          columns={columns}
          filterControls={filterControls}
          rows={vouchers}
          pagination={pagination}
          role={role}
          search={true}
          placeholders="ID, name, description"
          init_filters={this.state.initFilters}
          merge_filters={this.state.merge_filters}
          rowGetter={this.props.getVouchers.bind(this)}
          fieldGetter={this.fieldGetter.bind(this)}
          current_view={this.state.current_view}
          handleStatus={this.handleStatus.bind(this)}
          classPrefix="vouchers"
          addClassField="status"
        />

        <CustomDialog
          id="delete-dialog"
          fullScreen = {false}
          qid={this.state.current_id}
          isopen={this.state.showDialog}
          handleClose={this.hideDialog.bind(this)}
          handleAccept={this.destroy.bind(this)}
          title="Delete Voucher?"
        >
          This action cannot be undone
        </CustomDialog>
      </div>
    )
  }
}

const VouchersIndex = connect(mapStateToProps, mapDispatchToProps)(ConnectedVouchersIndex)

export default withStyles(styles)(VouchersIndex)



// WEBPACK FOOTER //
// ./src/js/components/VouchersIndex.js